import { Link } from 'react-router-dom'
import Footer from '../../components/layout/Footer'

export default function TermsPage() {
  return (
    <div className="min-h-screen flex flex-col bg-paper text-ink">
      <header className="border-b border-line">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo-ax.svg" alt="ax-kanban" className="h-10 w-auto" />
          </Link>
          <Link to="/login" className="text-sm text-brand-600 dark:text-brand-300 hover:text-brand-700 dark:text-brand-300 font-medium">
            Voltar ao login →
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-10 prose prose-gray prose-headings:font-bold prose-headings:text-ink prose-p:text-ink-muted">
        <h1 className="text-3xl font-bold text-ink mb-2">Termos de Uso</h1>
        <p className="text-sm text-ink-faint">Última atualização: 14 de maio de 2026</p>

        <section className="mt-8 space-y-6">
          <div>
            <h2 className="text-xl font-semibold mb-2">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar ou utilizar a plataforma BX Solutions (doravante "BX" ou "Plataforma"),
              operada pela <strong>Ax Business & Solutions</strong>, você concorda integralmente com
              estes Termos de Uso e com nossa <Link to="/privacidade" className="text-brand-600 dark:text-brand-300 hover:underline">Política de Privacidade</Link>.
              Se não concorda, não utilize o serviço.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">2. Descrição do Serviço</h2>
            <p>
              A BX é uma plataforma SaaS multi-tenant para gestão de reposição de estoque,
              análise de curva ABC, emissão de pedidos de compra e integração com sistemas ERP
              (atualmente Tiny). Funcionalidades podem ser adicionadas ou removidas a qualquer
              momento, com aviso prévio quando aplicável.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">3. Cadastro e Conta</h2>
            <p>
              O acesso é concedido mediante convite enviado pela equipe BX ou por administrador
              de uma empresa contratante. O usuário é responsável por:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Manter suas credenciais (e-mail e senha) em sigilo;</li>
              <li>Informar dados verídicos e atualizados;</li>
              <li>Notificar imediatamente o suporte em caso de uso não autorizado da sua conta;</li>
              <li>Não compartilhar acesso com terceiros fora da empresa contratante.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">4. Uso Aceitável</h2>
            <p>O usuário se compromete a NÃO:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Usar a Plataforma para atividades ilegais ou que violem direitos de terceiros;</li>
              <li>Tentar burlar mecanismos de segurança, autenticação ou cobrança;</li>
              <li>Realizar engenharia reversa, scraping massivo ou cópia da plataforma;</li>
              <li>Sobrecarregar intencionalmente a infraestrutura.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">5. Planos e Pagamento</h2>
            <p>
              Os planos comerciais são negociados individualmente com cada empresa contratante.
              A vigência, valores e condições constam em contrato específico ou proposta comercial
              acordada entre as partes. A inadimplência pode resultar em suspensão de acesso até
              regularização.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">6. Dados do Cliente</h2>
            <p>
              Os dados inseridos pelo cliente na Plataforma (produtos, vendas, fornecedores etc.)
              permanecem de propriedade do cliente. A BX atua como operadora desses dados,
              limitada ao necessário para prestação do serviço. Consulte a
              <Link to="/privacidade" className="text-brand-600 dark:text-brand-300 hover:underline"> Política de Privacidade</Link>
              {' '}para detalhes sobre coleta, uso, retenção e eliminação.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">7. Disponibilidade e Manutenção</h2>
            <p>
              Nos esforçamos para manter a Plataforma sempre disponível, mas não garantimos
              operação ininterrupta. Janelas de manutenção planejadas serão comunicadas com
              antecedência razoável. Em casos de incidente, faremos o melhor esforço para
              restauração, conforme RPO/RTO definidos em runbook interno.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">8. Limitação de Responsabilidade</h2>
            <p>
              Na máxima extensão permitida por lei, a BX não responde por danos indiretos,
              lucros cessantes ou perda de oportunidades decorrentes do uso ou indisponibilidade
              da Plataforma. A responsabilidade total da BX em qualquer caso fica limitada ao
              valor pago pelo cliente nos 12 meses anteriores ao evento.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">9. Rescisão</h2>
            <p>
              O cliente pode encerrar o uso a qualquer momento, com 30 dias de antecedência.
              A BX pode encerrar contas em caso de violação destes Termos, inadimplência ou
              descontinuação do serviço (com aviso prévio de 60 dias neste último caso).
              Após o encerramento, dados são retidos por 30 dias antes da exclusão definitiva
              (ver Política de Privacidade).
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">10. Alterações nestes Termos</h2>
            <p>
              Podemos atualizar estes Termos a qualquer momento. Alterações materiais serão
              comunicadas por e-mail aos administradores das empresas contratantes com pelo
              menos 15 dias de antecedência.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">11. Lei Aplicável e Foro</h2>
            <p>
              Estes Termos são regidos pelas leis da República Federativa do Brasil.
              Fica eleito o foro da comarca do estabelecimento da BX para dirimir quaisquer
              controvérsias, com renúncia a qualquer outro, por mais privilegiado que seja.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">12. Contato</h2>
            <p>
              Dúvidas, sugestões ou notificações: <a href="mailto:contato@bx.tec.br" className="text-brand-600 dark:text-brand-300 hover:underline">contato@bx.tec.br</a>
            </p>
          </div>
        </section>
      </main>

      <Footer variant="light" />
    </div>
  )
}
